$(document).ready(function () {

  $(".so-tab").each(function (i, element) {

    $(element).find('label').bind('click', function () {
      $(this).addClass("openTab");

    });


  });

  function titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  function mainsearch(ele, searchedText) {

    //console.log(searchedText);
    $(ele + ":contains('" + searchedText + "')").each(function (i, element) {

      var page = $(element);
      var pageText = page.text().replace("<span class=\"search-found\">", "").replace("</span>");
      //var searchedText = $('#searchfor').val();
      var theRegEx = new RegExp("(" + searchedText + ")", "igm");
      var newHtml = pageText.replace(theRegEx, "<span class=\"search-found\">$1</span>");
      page.html(newHtml);
      if ($(element).closest("div").prev().find('span').closest("label").not('.openTab').length) {

        $(element).closest("div").prev().find('span').closest("label").trigger("click");
        $(element).closest("div").prev().find('span').closest("label").addClass("openTab");
        // console.log( " faq clicked!" );

      }

    });

  }


  function mainremove(ele) {

    $(ele).each(function (i, element) {
      var page_1 = $(element);
      var pageText = page_1.text().replace("<span class=\"search-found\">", "").replace("</span>");
      page_1.html(pageText);

    });

  }


  function searchfaq() {
    var searchedText = $('#searchText').val();


    var searchedTextTitle = titleCase(searchedText);
    mainremove('span');
    mainremove('p');
    mainremove('em');


    mainsearch('span', searchedTextTitle);
    mainsearch('span', searchedText);
    mainsearch('p', searchedTextTitle);
    mainsearch('p', searchedText);
    mainsearch('em', searchedTextTitle);
    mainsearch('em', searchedText);

    $([document.documentElement, document.body]).animate({
      scrollTop: ($('.search-found').offset().top - 200)
    }, 2000);
  }

  $('#searchFaqBtn').on('click', function () {
    searchfaq();

  });
  $('#searchText').keypress(function (event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == '13') {
      searchfaq();
    }
  });

});